<template>
  <div>
    <el-time-select class="h-40 mw-240 w-100p" v-model="childValue" :placeholder="placeholder" format="HH:mm" :disabled="disabled" @input="change" v-if="fixedStep" :picker-options="pickerOptions"></el-time-select>
    <el-select class="h-40 mw-240 w-100p" v-model="childValue" filterable clearable :placeholder="placeholder" @input="change" :disabled="disabled" v-if="notFixedStep">
      <el-option
       v-for="item in timeConfig"
       :label="item.value"
       :value="item.value">
      </el-option>
     </el-select>
    <el-time-picker class="h-40 mw-240 w-100p" v-model="childValue" :placeholder="placeholder" format="HH:mm:ss" :disabled="disabled" :picker-options="pickerOptions" :is-range="isRange" @input="change" v-if="typeAnytime" ></el-time-picker>
  </div>
</template>
<script>
  /**
   * @param Number value 绑定值（时间戳）
   * @param String name 控件名
   * @param Boolean disabled 是否禁用
   * @param Array rules 表单验证规则
   * @param Object config 配置值
   * @param String placeholder 提示语
   * @param Number type 类型
   * @param Boolean isRange 是否范围
   */
  // 输入：字符串；转换为：Date对象；输出：字符串
  import modelConfig from '../../../../config/modelConfig'
  import _verify from '../../../../assets/js/verify'
  export default {
    props: ['value', 'name', 'disabled', 'rules', 'config', 'placeholder', 'type', 'isRange'],
    data() {
      return {
        COMPONENT_NAME: 'honrayTime',
        childValue: null,
        timeConfig: [],
        pickerOptions: []
      }
    },
    created() {
      this.initData()
      this.init()
    },
    methods: {
      initData() {
        if (this.value) {
          this.childValue = this.parseTime(this.value)
        } else if (this.value == null) {
          this.setDefaultValue()
        } else {
          if (this.isRange) { // 范围
            this.childValue = []
          } else {  // 单时间
            this.childValue = ''
          }
        }
      },
      init() {
        if (this.type == this.TIME_ANYTIME) { // 任意时间，需设置可选时间范围
          this.setSelectRange()
        } else if (this.type == this.TIME_FIXED &&
                   this.config.fixed_step == this.TIME_FIXED_STEP_TRUE) { // 固定时间不固定间隔
          this.setFixedStep()
        } else if (this.type == this.TIME_FIXED &&
          this.config.fixed_step == this.TIME_FIXED_STEP_FALSE) { // 固定时间且不固定间隔，需设置可选选项
          this.setTimeConfig()
        }
      },
      parseTime(value) {
        let outputValue = ''
        if (value.indexOf(' to ') > -1) { // 范围
          outputValue = value.split(' to ')
          if (this.vaildTime(outputValue[0], 'time') && this.vaildTime(outputValue[1], 'time')) {
            let outputStart = new Date(`1970-01-01 ${outputValue[0]}`)
            let outputEnd = new Date(`1970-01-01 ${outputValue[1]}`)
            if (this.isTypeDate(outputStart) && this.isTypeDate(outputEnd)) {
              return [outputStart, outputEnd]
            } else {
              return []
            }
          } else {
            return ''
          }
        } else {
          if (this.vaildTime(value, 'time')) {
            if (this.type == this.TIME_FIXED) {
              if (this.config.fixed_step == this.TIME_FIXED_STEP_FALSE) { // 不固定间隔时间
                return value
              } else if (this.config.fixed_step == this.TIME_FIXED_STEP_TRUE) {
                outputValue = new Date(`1997-01-01 ${value}`)
                if (this.isTypeDate(outputValue)) {
                  return value
                } else {
                  return ''
                }
              }
            } else if (this.type == this.TIME_ANYTIME) {
              outputValue = new Date(`1997-01-01 ${value}`)
              if (this.isTypeDate(outputValue)) {
                return outputValue
              } else {
                return ''
              }
            }
          } else {
            return ''
          }
        }
      },
      setSelectRange() { // 设置可选范围
        let timeMin = null
        let timeMax = null
        if (this.config.time_min.type == this.DATE_LIMIT_VAR) { // 最小值类型为变量公式
          timeMin = this.parseFormula(this.config.time_min.var_limit)
          timeMin = moment(timeMin).format('HH:mm:ss')
        } else if (this.config.time_min.type == this.DATE_LIMIT_FIXED) { // 最小值类型为固定值
          timeMin = new Date(this.config.time_min.fixed_value)
          timeMin = moment(timeMin).format('HH:mm:ss')
        }
        if (this.config.time_max.type == this.DATE_LIMIT_VAR) { // 最大值类型为变量公式
          timeMax = this.parseFormula(this.config.time_max.var_limit)
          timeMax = moment(timeMax).format('HH:mm:ss')
        } else if (this.config.time_max.type == this.DATE_LIMIT_FIXED) { // 最大值类型为固定值
          timeMax = new Date(this.config.time_max.fixed_value)
          timeMax = moment(timeMax).format('HH:mm:ss')
        }
        if (timeMin && timeMax) { // 最大最小值都有
          this.pickerOptions = {
            selectableRange: `${timeMin} - ${timeMax}`
          }
        } else if (timeMin) { // 只有最小值
          this.pickerOptions = {
            selectableRange: `${timeMin} - 23:59:59`
          }
        } else if (timeMax) { // 只有最大值
          this.pickerOptions = {
            selectableRange: `00:00:00 - ${timeMax}`
          }
        }
      },
      setFixedStep() {  // 设置固定间隔选项
        let timeMin = null
        let timeMax = null
        if (this.config.time_min.type == this.DATE_LIMIT_VAR) { // 最小值类型为变量公式
          timeMin = this.parseFormula(this.config.time_min.var_limit)
          timeMin = moment(timeMin).format('HH:mm')
        } else if (this.config.time_min.type == this.DATE_LIMIT_FIXED) { // 最小值类型为固定值
          timeMin = new Date(this.config.time_min.fixed_value)
          timeMin = moment(timeMin).format('HH:mm')
        }
        if (this.config.time_max.type == this.DATE_LIMIT_VAR) { // 最大值类型为变量公式
          timeMax = this.parseFormula(this.config.time_max.var_limit)
          timeMax = moment(timeMax).format('HH:mm')
        } else if (this.config.time_max.type == this.DATE_LIMIT_FIXED) { // 最大值类型为固定值
          timeMax = new Date(this.config.time_max.fixed_value)
          timeMax = moment(timeMax).format('HH:mm')
        }
        let step = this.config.time_step
        if (!(step && this.vaildTime(step, 'm'))) {
          step = '00:01'
        }
        if (timeMin && timeMax) { // 最大最小值都有
          this.pickerOptions = {
            start: timeMin,
            step: step,
            end: timeMax
          }
        } else if (timeMin) { // 只有最小值
          this.pickerOptions = {
            start: timeMin,
            step: step,
            end: '23:59'
          }
        } else if (timeMax) { // 只有最大值
          this.pickerOptions = {
            start: '00:00',
            step: step,
            end: timeMax
          }
        }
      },
      setDefaultValue() { // 设置默认值
        if (this.config.time_default.default_type != this.TIME_DEFAULT_NULL) { // 有设置默认值
          if (this.config.time_default.default_type == this.TIME_DEFAULT_VAR) { // 默认值为变量公式
            if (!this.isRange) { // 不是范围
              let defaultTime = this.parseFormula(this.config.time_default.single)
              if (this.type == this.TIME_FIXED && this.config.fixed_step == 1) { // 固定时间+固定间隔
                let parseResult = moment(defaultTime).format('HH:mm')
                if (this.vaildTime(parseResult, 'm')) {
                  this.childValue = parseResult
                } else {
                  this.childValue = ''
                }
              } else { // 任意时间
                if (this.isTypeDate(defaultTime)) {
                  this.childValue = defaultTime
                } else {
                  this.childValue = ''
                }
              }
            } else { // 范围
              let defaultStart = this.parseFormula(this.config.time_default.range_start)
              let defaultEnd = this.parseFormula(this.config.time_default.range_end)
              if (this.isTypeDate(defaultStart) && this.isTypeDate(defaultEnd)) { // 判断时间值是否合法
                this.childValue = [defaultStart, defaultEnd]
              } else {
                this.childValue = []
              }
            }
          } else if (this.config.time_default.default_type == this.TIME_DEFAULT_FIXED) { // 默认值为固定值
            if (!this.isRange) { // 不是范围
              if (this.type == this.TIME_FIXED && this.config.fixed_step == 0) { // 固定时间+不固定间隔
                let defaultTime = new Date(this.config.time_default.fixed_value)
                if (this.isTypeDate(defaultTime)) {
                  this.childValue = moment(defaultTime).format('HH:mm')
                } else {
                  this.childValue = ''
                }
              } else if (this.type == this.TIME_FIXED && this.config.fixed_step == 1) { // 固定时间+固定间隔
                let defaultTime = this.config.time_default.fixed_value
                if (this.vaildTime(defaultTime, 'm')) {  // 判断时间值是否合法
                  this.childValue = defaultTime
                } else {
                  this.childValue = ''
                }
              } else { // 任意时间
                let defaultTime = new Date(this.config.time_default.fixed_value)
                if (this.isTypeDate(defaultTime)) {  // 判断时间值是否合法
                  this.childValue = defaultTime
                } else {
                  this.childValue = ''
                }
              }
            } else { // 范围
              let defaultTime = this.config.time_default.fixed_value.split(' to ')
              let defaultStart = new Date(defaultTime[0])
              let defaultEnd = new Date(defaultTime[1])
              if (this.isTypeDate(defaultStart) && this.isTypeDate(defaultEnd)) { // 判断时间值是否合法
                this.childValue = [defaultStart, defaultEnd]
              } else {
                this.childValue = []
              }
            }
          }
        } else {
          if (this.isRange) {
            this.childValue = []
          } else {
            this.childValue = ''
          }
        }
        this.change(this.childValue)
      },
      setTimeConfig() { // 设置快捷选项
        if (this.config.time_config && this.config.time_config.length) {
          _(this.config.time_config).forEach((res) => {
            this.timeConfig.push({
              value: moment(res.value).format('HH:mm')
            })
          })
        }
      },
      parseFormula(value) { // 解析公式
        if (value) {
          let valueTrim = value.trim().replace(/\s/g, '') // 去空格
          let formulaArr = valueTrim.split('&')
          let result = moment(new Date())
          _(formulaArr).forEach((formula) => {
            let hasPlus = formula.indexOf('+') > -1
            let hasMinus = formula.indexOf('-') > -1
            let unit = 'hours'
            if (formula.indexOf('h') > -1) { // 时
              unit = 'hours'
            } else if (formula.indexOf('m') > -1) { // 分
              unit = 'minutes'
            } else if (formula.indexOf('s') > -1) { // 秒
              unit = 'seconds'
            }
            if (unit) {
              let splitResult = ''
              let number = 0
              let times = 1
              if (hasPlus) {
                splitResult = formula.split('+')
                times = 1
              } else if (hasMinus) {
                splitResult = formula.split('-')
                times = -1
              }
              if (hasPlus || hasMinus) {
                _(splitResult).forEach((res) => { // 遍历切割的数组，把数字减掉
                  if ((/^[0-9\.]+$/g).test(res)) {
                    number += parseFloat(res) * times
                  }
                })
              }
              result.add(number, unit)
            }
          })
          return new Date(result)
        } else {
          return ''
        }
      },
      vaildTime(value, unit) {
        if (unit == 'm') {
          // 验证格式：00:00
          return (/^\d{2}\:\d{2}$/).test(value)
        } else if (unit == 's') {
          // 验证格式：00:00:00
          return (/^\d{2}\:\d{2}\:\d{2}$/).test(value)
        } else if (unit == 'time') {
          return (/^\d{2}\:\d{2}$/).test(value) || (/^\d{2}\:\d{2}\:\d{2}$/).test(value)
        }
      },
      isTypeDate (value) {
        return typeof value == 'object' && value.getDate
      },
      change(value) {
        let outputValue = ''
        if (value || value.length) {
          if (this.type == this.TIME_ANYTIME) { // 任意时间
            if (this.isRange && this.isTypeDate(value[0]) && this.isTypeDate(value[1])) {
              outputValue = `${moment(value[0]).format('HH:mm:ss')} to ${moment(value[1]).format('HH:mm:ss')}`
            } else if (!this.isRange && this.isTypeDate(value)) {
              outputValue = moment(value).format('HH:mm:ss')
            }
          } else {
            outputValue = value
          }
        }
        this.$emit('input', outputValue)
      }
    },
    computed: {
      fixedStep() { // 类型为固定时间且间隔固定
        return this.type == this.TIME_FIXED && this.config.fixed_step == this.TIME_FIXED_STEP_TRUE
      },
      notFixedStep() { // 类型为固定时间且间隔不固定
        return this.type == this.TIME_FIXED && this.config.fixed_step == this.TIME_FIXED_STEP_FALSE
      },
      typeAnytime() { // 类型为任意时间
        return this.type == this.TIME_ANYTIME
      }
    },
    watch: {
      'value'() {
        if (this.value != this.childValue) {
          this.initData()
        }
      }
    },
    mixins: [modelConfig]
  }
</script>



// WEBPACK FOOTER //
// honrayTime.vue?24ec1023